import axios from "axios";

export async function authenticateForMcpToken(username, password) {
    const formData = "username=" + encodeURIComponent(username) + "&password=" + encodeURIComponent(password);
    const result = await axios.post("/security/authenticate", formData);
    return result.data.token;
}

export default { authenticateForMcpToken };
